import axios from 'axios'

export const state = {
  files: null,
}

export const getters = {
  files: (state) => state.files,
}

export const mutations = {
  SET_FILES(state, files) {
    state.files = files
  },
}

export const actions = {
  fetchAllFiles({ commit }, documentId) {
    return axios.get(`/api/documents/${documentId}/files`).then((response) => {
      const files = response.data
      commit('SET_FILES', files)
      return files
    })
  },

  createFile(_, payload) {
    const formData = new FormData()
    formData.append('file', payload.file)

    return axios.post(`/api/documents/${payload.documentId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  createUrl(_, payload) {
    return axios.post(`/api/documents/${payload.documentId}/files`, payload)
  },

  deleteFile(_, payload) {
    return axios.delete(
      `/api/documents/${payload.documentId}/files/${payload.id}`,
    )
  },
}
